<template>
  <el-breadcrumb class="app-breadcrumb" >
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="item.redirect === 'noRedirect' || index == levelList.length - 1" class="no-redirect">{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script setup>
import usePermissionStore from "@/store/modules/permission";
import { getHomePath } from "@/modules/huyu-framework/backend/utils/routeHelper";

const route = useRoute();
const router = useRouter();
const levelList = ref([])
const permissionStore = usePermissionStore();

// 动态首页路径（本项目路由全动态，不写死 /index）
const homePath = computed(() => getHomePath(permissionStore.sidebarRouters));

function getBreadcrumb() {
  // only show routes with meta.title
  let matched = route.matched.filter(item => item.meta && item.meta.title);
  // 当前不在首页时，前置可点击的「首页」面包屑（路径动态解析，点击不会 404）
  if (homePath.value && route.path !== homePath.value) {
    matched = [{ path: homePath.value, meta: { title: '首页' } }].concat(matched)
  }

  levelList.value = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
}
function handleLink(item) {
  const { redirect, path } = item
  if (redirect) {
    router.push(redirect)
    return
  }
  router.push(path)
}

watchEffect(() => {
  // if you go to the redirect page, do not update the breadcrumbs
  if (route.path.startsWith('/redirect/')) {
    return
  }
  getBreadcrumb()
})
getBreadcrumb();
</script>

<style lang='scss' scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>